import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";

import AssistantPanelLayout from "./Layout";
import useAssistantPanelStore from "./Layout/useStore";
import AssistantPanelAsk from "./Ask";
import { AssistantPanelMode } from "./Layout/types";
import AssistantPanelHome from "./Home";
import AssistantPanelLearn from "./Learn";

const AssistantPanel = () => {
  const mode = useAssistantPanelStore(useShallow((state) => state.mode));

  const children = useMemo(() => {
    switch (mode) {
      case AssistantPanelMode.AI_CHAT:
        return <AssistantPanelAsk />;
      case AssistantPanelMode.LEARN:
        return <AssistantPanelLearn />;
      case AssistantPanelMode.HOME:
        return <AssistantPanelHome />;
    }
  }, [mode]);

  return <AssistantPanelLayout>{children}</AssistantPanelLayout>;
};

export default AssistantPanel;
